import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Card from 'components/_new/layout/Card/Card'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './PlanCard.scss'


const PlanCard = (props) => {
  const { children, className, discount, saveValue } = props
  const isBasePlan = !discount && !saveValue

  const planClassName = cx(s.plan, className, {
    [s.basePlan]: isBasePlan,
  })

  return (
    <Card className={planClassName} dataTestId="upgradePlanOption">
      {
        !isBasePlan && (
          <Box className={s.discount} p="16">
            <Text size="38-48" bold message={discount} />
            <Text size="18-24" semibold uppercase message={messages.off} />
          </Box>
        )
      }
      <div className={s.content}>
        {children}
      </div>
    </Card>
  )
}

PlanCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  discount: PropTypes.string,
  saveValue: PropTypes.string,
}


export default PlanCard
